<template>
    <div v-if="show" class="root mask">
        <div class="dlg-move flex flex-col border-box">
            <div class="flex flex-space-between full-width">
                <div class="font-bold">移动至</div>
                <div class="pointer" @click="close"><img class="logo-22" src="@/assets/images/guanbi.png"/></div>
            </div>
            <vue-custom-scrollbar style="height:250px" >
                <TreeView  :dirData="dirData" @change="change"></TreeView>
            </vue-custom-scrollbar>
            <div class="margin-top-xl btn-blue-auto full-width pointer" @click="selectMove">确定</div>
      </div>

    </div>
</template>

<script>
    import TreeView from '@/components/tree/TreeView' //引入我们写好的递归组件
    import {objToStr} from '@/utils/sysUtils'

    export default{
        name:'Move',
        props:{
            show:{},
            dirData:{}
        },
        components:{
            TreeView
        },
        data() {
            return {
                selectId: "",
                selectName:"",
            }
        },
        methods:{
            close() {
                this.$emit("close")
            },
            change(id,name) {
                this.selectId = id;
                this.selectName = name;

            },
            selectMove() {
                console.log(this.selectId)
                if (objToStr(this.selectId) === "") {
                    this.$showToast({msg:"请选择要移动到的目录"})
                    return false;
                }
                this.$emit("change",this.selectId);
    
            },
        
        }
    }
</script>

<style scoped>
  .dlg-move {
        border-radius: 5px;
        width: 400px;
        height: 350px;
        background-color: #fff;
        padding: 20px;
        /* 使用绝对地位，父级元素必须有定位属性 */
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
  }
  

</style>


// WEBPACK FOOTER //
// src/modules/move/Move.vue